<script>
import scrollMixin from '@/mixins/scrollWheelMixin';

export default {
  mixins: [scrollMixin],
  props: {
    defaultQuantity: { type: Number, default: 0 },
    showGlobal: { type: Boolean, default: true },
    returnedObject: { default: null },
    defaultIsEditingPrice: { default: false },
    target: { type: String, required: true },
    title: { type: String, required: true },
    placement: { type: String, default: 'left' },
  },
  data() {
    return {
      isEditingPrice: false,
    };
  },
  methods: {
    hidePopover() {
      this.isEditingPrice = false;
    },
    showPopover() {
      this.isEditingPrice = this.defaultIsEditingPrice;
    },
    popoverShown() {
      this.$refs[`${this.target}-input`].focus();
    },
    closePopover() {
      this.$refs[`${this.target}-popover`].$emit('close');
    },
    acceptPriceLocally() {
      this.emitPriceDecision('accept-price-locally');
    },
    acceptPriceGlobally() {
      this.emitPriceDecision('accept-price-globally');
    },
    emitPriceDecision(emitString) {
      let price = this.defaultQuantity;

      if (this.isEditingPrice) {
        price = this.$refs[`${this.target}-input`].$el.value;
      }

      if (price < 0) {
        price = 0;
      }

      this.$emit(emitString, Number(price).toFixed(5), this.returnedObject);
      this.closePopover();
    },
    startEditingPrice() {
      this.isEditingPrice = true;
    },
    wheelEditPopoverQuantity(event) {
      let currValue = +event.target.value;
      event.target.value = this.scrollMixinEvent(event, currValue);
    },
  },
};
</script>

<template>
  <b-popover
    :ref="target + '-popover'"
    :target="target"
    triggers="click"
    :placement="placement"
    @hide="hidePopover"
    @show="showPopover"
    @shown="popoverShown"
  >
    <template #title>
      <div class="flex-box">
        <div>{{ title }}</div>
        <div class="flex-push pl-3">
          <i
            class="fas fa-times text-secondary pl-2 pr-2"
            @click="closePopover()"
            style="cursor: pointer; font-size: 1.3em"
          ></i>
        </div>
      </div>
    </template>
    <div v-show="isEditingPrice" style="width: 250px; display: grid; gap: 1em">
      <b-form-input
        type="number"
        :ref="`${target}-input`"
        :value="defaultQuantity"
        step=".01"
        min="0"
        @wheel.prevent="wheelEditPopoverQuantity($event)"
        tabindex="-1"
        :placeholder="$t('items.quantity')"
      ></b-form-input>

      <b-button
        v-if="showGlobal"
        @click="acceptPriceGlobally"
        class="font-size-14"
        variant="success"
      >
        {{ $t('orders.acceptPriceGlobally') }}
      </b-button>

      <b-button
        @click="acceptPriceLocally"
        class="font-size-14"
        variant="secondary"
      >
        {{ $t('orders.acceptPriceLocally') }}
      </b-button>
    </div>
    <div
      v-show="isEditingPrice == false"
      style="width: 250px; display: grid; gap: 1em"
    >
      <b-button
        v-if="showGlobal"
        @click="acceptPriceGlobally"
        class="font-size-14"
        variant="success"
      >
        {{ $t('orders.acceptPriceGlobally') }}
      </b-button>

      <b-button
        @click="acceptPriceLocally"
        class="font-size-14"
        variant="secondary"
      >
        {{ $t('orders.acceptPriceLocally') }}
      </b-button>

      <b-button
        @click="startEditingPrice"
        class="font-size-14"
        variant="danger"
      >
        {{ $t('orders.editPrice') }}
      </b-button>
    </div>
  </b-popover>
</template>
